import React, { useContext } from 'react';
import Headline from 'headline';
import Button from 'button';
import Loading from 'shared/loading';
import Input from 'shared/form-input';
import FirebaseContext from 'context/firebase';
import { useSubmitState } from 'hooks/useSubmitState';
import { useFormInput } from 'hooks/useForm';
import { navigate } from 'gatsby';
import '@firebase/database';
import s from './form.module.scss';

export default function AsideForm({ title, button, form_title, form_button }) {
  const name = useFormInput('');
  const ig = useFormInput('');
  const email = useFormInput('');

  const firebase = useContext(FirebaseContext);

  function sendToZapier(event) {
    event.preventDefault();
    const body = {
      name: name.state.value,
      ig_username: ig.state.value,
      email: email.state.value
    };
    firebase
      .database()
      .ref('/contact-form/')
      .push(body);
  }

  const buttonState = useSubmitState(sendToZapier, form_button.text, Loading);

  return (
    <div className={s.root}>
      <div className={s.background} />
      <div className={s.wrapper}>
        <Headline h3 className={s.headline} html={title} />
        <Button className={s.button} href={button.href}>
          {button.text}
        </Button>
        <div className={s.separator} />
      </div>
      <div className={s.wrapper}>
        <Headline h3 className={s.subtitle} html={form_title} />
        <form>
          <Input
            className={s.formInput}
            {...name.events}
            value={name.state.value}
            type="text"
            name="name"
            placeholder="Full Name"
          />
          <Input
            className={s.formInput}
            {...ig.events}
            value={ig.state.value}
            type="text"
            name="igUsername"
            placeholder="Instagram @Username"
          />
          <Input
            className={s.formInput}
            {...email.events}
            value={email.state.value}
            type="text"
            name="email"
            placeholder="Email"
          />
        </form>
        <Button
          className={s.submit}
          disabled={buttonState.disabled}
          onClick={buttonState.submitHandler}
        >
          {buttonState.child}
        </Button>
      </div>
    </div>
  );
}
